<template>
    <div>

        <div class="center c100" :class="progress" v-on:click="togglePlay">
            <span v-if="playing" class="ico vox-mdi-pause"></span>
            <span v-else class="ico vox-mdi-play"></span>
            <div class="slice">
                <div class="bar"></div>
                <div class="fill"></div>
            </div>
        </div>

    </div>
</template>

<script>
    import AudioAPI from "../services/AudioAPI"
    import LocalStorage from "../services/LocalStorage"

    export default {
        data() {
            return {
                playing: false,
                progress: 'p0',
            }
        },

        mounted() {
            AudioAPI.setSrc(this.content.src)
            AudioAPI.setStepId(this.stepId)
            AudioAPI.init()

            const offset = LocalStorage.getMediaOffset(this.stepId)
            this.updateProgress(offset)
            if (offset > 0) {
                this.$emit('started')
            }

            document.addEventListener("audio-playing", (event) => {
                this.updateProgress(event.detail)
            });
        },

        props: {
            content: Object,
            stepId: Number
        },

        computed: {},

        methods: {
            togglePlay() {
                if (this.playing) {
                    AudioAPI.pause()
                } else {
                    AudioAPI.play()
                    this.$emit('started')
                }
                this.playing = !this.playing
            },

            updateProgress(offset) {
                let progress = Math.floor(100 * offset / (this.content.duration - 1))
                if (progress > 100) {
                    progress = 100
                }
                if (progress === 100) {
                    this.playing = false
                }
                this.progress = 'p' + progress
            }
        }
    }
</script>

<style lang="scss">
    $circle-width: 0.1em;
    $circle-width-hover: 0.05em;
    // colors default
    $primary-color: #307bbb;
    $secondary-color: #ccc;
    $bg-color: #f5f5f5;
    $primary-color-green: #4db53c;
    $primary-color-orange: #dd9d22;
    // colors dark skin
    $primary-color-dark: #c6ff00;
    $secondary-color-dark: #777;
    $bg-color-dark: #666;
    $primary-color-green-dark: #5fd400;
    $primary-color-orange-dark: #e08833;

    @mixin border-radius($radius) {
        -webkit-border-radius: $radius;
        -moz-border-radius: $radius;
        -ms-border-radius: $radius;
        border-radius: $radius;
    }

    @mixin rotate($rotation) {
        -webkit-transform: rotate($rotation);
        -moz-transform: rotate($rotation);
        -ms-transform: rotate($rotation);
        -o-transform: rotate($rotation);
        transform: rotate($rotation);
    }

    @mixin box-sizing($box-sizing) {
        -webkit-box-sizing: $box-sizing;
        -moz-box-sizing: $box-sizing;
        box-sizing: $box-sizing;
    }

    @mixin transition-property($transition) {
        -webkit-transition-property: $transition;
        -moz-transition-property: $transition;
        -o-transition-property: $transition;
        transition-property: $transition;
    }

    @mixin transition-duration($duration) {
        -webkit-transition-duration: $duration;
        -moz-transition-duration: $duration;
        -o-transition-duration: $duration;
        transition-duration: $duration;
    }

    @mixin transition-timing-function($timing) {
        -webkit-transition-timing-function: $timing;
        -moz-transition-timing-function: $timing;
        -o-transition-timing-function: $timing;
        transition-timing-function: $timing;
    }


    // VARS
    $circle-width: 0.08em;
    $circle-width-hover: 0.04em;

    // colors default
    $primary-color: #307bbb;
    $secondary-color: #ccc;
    $bg-color: #f5f5f5;

    $primary-color-green: #4db53c;
    $primary-color-orange: #dd9d22;


    // CIRCLE
    // classes 2 extend
    .rect-auto {
        clip: rect(auto, auto, auto, auto);
    }

    .pie {
        position: absolute;
        border: $circle-width solid $primary-color;
        width: 1 - (2 * $circle-width);
        height: 1 - (2 * $circle-width);
        clip: rect(0em, 0.5em, 1em, 0em);
        border-radius: 50%;
        @include rotate(0deg);
    }

    .pie-fill {
        @include rotate(180deg);
    }


    // main
    .c100 {

        *, *:before, *:after {
            @include box-sizing(content-box);
        }

        position: relative;
        font-size: 120px;
        width: 1em;
        height: 1em;
        border-radius: 50%;
        float: left;
        margin: 0 0.1em 0.1em 0;
        background-color: $secondary-color;

        // center circle to its parent
        &.center {
            float: none;
            margin: 0 auto;
        }


        // centered value inside circle
        > span {
            position: absolute;
            width: 100%;
            z-index: 1;
            left: 0;
            top: 0;
            width: 1.25em;
            line-height: 1.25em;
            font-size: 0.8em;
            color: $secondary-color;
            display: block;
            text-align: center;
            white-space: nowrap;
            @include transition-property(all);
            @include transition-duration(0.2s);
            @include transition-timing-function(ease-out);
        }

        // background inside the circle
        &:after {
            position: absolute;
            top: $circle-width;
            left: $circle-width;
            display: block;
            content: " ";
            border-radius: 50%;
            background-color: $bg-color;
            width: 1 - (2 * $circle-width);
            height: 1 - (2 * $circle-width);
            @include transition-property(all);
            @include transition-duration(0.2s);
            @include transition-timing-function(ease-in);

        }

        // the slice (mask)
        .slice {
            position: absolute;
            width: 1em;
            height: 1em;
            clip: rect(0em, 1em, 1em, 0.5em);
        }

        // circle to show the status
        .bar {
            @extend .pie;
        }


        // loop to create all needed elements automatically
        @for $j from 51 through 100 {

            &.p#{$j} .slice {
                @extend .rect-auto;
            }

            &.p#{$j} .bar:after {
                @extend .pie-fill;
            }

            &.p#{$j} .fill {
                @extend .pie;
                @extend .pie-fill;
            }

        }

        // loop to rotate all 100 circles
        @for $j from 1 through 100 {
            &.p#{$j} .bar {
                @include rotate((360/100*$j) + deg);
            }
        }


        // hover styles
        &:hover {
            cursor: pointer;

            > span {
                color: $primary-color;
            }

            &:after {
                top: $circle-width-hover;
                left: $circle-width-hover;
                width: 1 - (2 * $circle-width-hover);
                height: 1 - (2 * $circle-width-hover);
            }

        }

    }
</style>
